import {
    FormControl,
    InputLabel,
    makeStyles,
    MenuItem,
    Select,
    TextField,
    Tooltip,
    Typography
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { productCategoryDetailsModalStyles } from '../styles';
import { MEDICAL_TYPES } from '../../../collums-constants';
import { Controller } from 'react-hook-form';
import HelpIcon from '@material-ui/icons/Info';
import OrganisationsApi from '../../../api/OrganisationsApi';

function GeneralTab({
    register,
    categories,
    isFromOrg,
    category,
    setValue,
    searchCategories,
    parent,
    setParent,
    allClinics,
    control
}) {
    const classes = makeStyles(productCategoryDetailsModalStyles)();
    //  const isRequired = category.id !== undefined ? { name: false, active: false } : { name: true, active: true };

    useEffect(() => {
        register({ name: 'parentId' });
        /* eslint-disable-next-line */
    }, []);

    const [organisationData, setOrganisationData] = useState(null);

    useEffect(() => {
        (async () => {
            const organisation = await OrganisationsApi.getOrganisation();
            setOrganisationData(organisation);
        })();
    }, []);

    return (
        <div className={classes.formContent}>
            <div className={classes.formContentRow}>
                <div style={{ display: 'flex', width: '100%' }}>
                    <TextField
                        inputProps={{ readOnly: !isFromOrg && allClinics.length > 1 }}
                        className={classes.formItem}
                        inputRef={register({ required: 'Name' })}
                        name="name"
                        label="Name"
                        variant="outlined"
                        defaultValue={category.name || ''}
                    />

                    <Autocomplete
                        disabled={!isFromOrg && allClinics.length > 1}
                        style={{ width: '48%' }}
                        options={categories}
                        value={parent}
                        getOptionLabel={option => option.name}
                        onChange={async (e, value) => {
                            setValue('parentId', value !== null ? value.id : undefined);
                            setParent(value);
                        }}
                        className={`${classes.autocomplete} ${classes.formItem}`}
                        renderInput={params => (
                            <TextField
                                {...params}
                                onChange={(e, value) => searchCategories(value)}
                                label="Parent Category"
                                variant="outlined"
                                className={classes.autocompleteTextField}
                            />
                        )}
                    />
                </div>

                <div style={{ display: 'flex', width: '100%' }}>
                    <TextField
                        inputProps={{ readOnly: !isFromOrg && allClinics.length > 1 }}
                        multiline="true"
                        className={classes.formItem}
                        inputRef={register}
                        rowsMax={3}
                        name="description"
                        label="Description"
                        variant="outlined"
                        defaultValue={category.description}
                    />
                    {organisationData?.isVat0Only && (
                        <FormControl
                            className={classes.formItem}
                            style={{ display: 'inline-block' }}
                            variant="outlined"
                        >
                            <InputLabel>Label all products as</InputLabel>
                            <Controller
                                name={'medical'}
                                control={control}
                                style={{ width: 'calc(100% - 20px)' }}
                                as={
                                    <Select>
                                        <MenuItem key="empty-medical" value="">
                                            &nbsp;
                                        </MenuItem>
                                        {Object.entries(MEDICAL_TYPES).map(([key, label]) => (
                                            <MenuItem key={key} value={key}>
                                                {label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                }
                            />
                            <Tooltip
                                placement="right"
                                title={
                                    <Typography style={{ fontSize: '14px', display: 'grid' }}>
                                        If you wish, label your products as cosmetic or medical to help with your
                                        reporting.
                                        <br />
                                        This label can be changed on the invoice at checkout by clicking on the circle
                                        icon.
                                        <br />
                                        If you have selected &quot;All my sales have 0% tax&quot; in Settings, changing
                                        this label will have no effect on the tax on the invoice. If you have NOT made
                                        this selection, changing the label on the invoice will change the tax (0% for
                                        medical, 20% for cosmetic).
                                    </Typography>
                                }
                                aria-label="help"
                            >
                                <HelpIcon className={classes.helpIcon} />
                            </Tooltip>
                        </FormControl>
                    )}
                </div>
            </div>
        </div>
    );
}

GeneralTab.propTypes = {
    register: PropTypes.func.isRequired,
    categories: PropTypes.array,
    control: PropTypes.any,
    watch: PropTypes.any
};

export default GeneralTab;
